import TransLink from '@tujia/fe-lib-common/lib/utils/translink'
import urlHelper from '@common-libs/utils/url-helper';

const transLinkIns = new TransLink()

/**
 * Links对象
 * @typedef {object} Links
 * @property {string} page - list|detail
 * @property {string} webUrl - m站地址
 * @property {string} tAppUrl - APPT端地址
 * @property {string} mpUrl - 小程序地址
 * @property {string} cAPPUrl - APPC端地址
 * @property {string} qAPPUrl - APPQ端地址
 */
/**
 * 根据page、params参数生成多端的页面地址
 * @param {string} page
 * @param {object} params
 * @param {string} params.cityId
 * @param {string} params.checkInDate
 * @param {string} params.checkOutDate
 * @param {string} params.cds
 * @param {string} params.channelId
 * @param {string} params.houseId
 * @return {Links} 返回页面地址集合
 */
export const getLinks = (page, params) => {
  return transLinkIns.getLink(page, params)
}
export const getMpLinkWithCode = (mpLink, h5Link, fromForLog) => {
  const code = fromForLog || urlHelper.queryString('code')
  if (mpLink.startsWith('/pages/tbnb/pages/main/')) {
    return mpLink + (mpLink.indexOf('code') !== -1 ? '' : `&code=${code}`)
  }
  let url = h5Link
  if (h5Link.indexOf('code=') === -1) {
    url +=  `${url.indexOf('?') > -1 ? '&' : '?'}code=${code}`
  }
  return `/pages/tbnb/pages/common/webview/index?h5url=${encodeURIComponent(url)}`
}